<script lang="ts">
    import { setFocusOnKeyDown } from "@apps/rewards/utils/setFocusOnKeyDown";
    import { BehaviorSubject } from "rxjs";

    //Variables
    let element: HTMLElement;

    //State
    const activeItem$ = new BehaviorSubject<string>("");
    const isItemMounted$ = new BehaviorSubject<boolean>(false);

    //Slot props
    const state = {
        isItemMounted$,
        activeItem$,
    };

    //Reactive Statement
    $: if ($isItemMounted$)
        setFocusOnKeyDown(element, { selector: "button", isFocusable: true });
</script>

<div class="gw-rd-accordion" bind:this={element}>
    <slot {state} />
</div>
